import { render, staticRenderFns } from "./SchoolFacialStaffTable.vue?vue&type=template&id=436ecb9e&scoped=true&"
import script from "./SchoolFacialStaffTable.vue?vue&type=script&lang=js&"
export * from "./SchoolFacialStaffTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436ecb9e",
  null
  
)

export default component.exports